export type GiftCardFilterId = 'all' | 'food' | 'shopping' | 'travel' | 'beauty';
export type GiftCardCategory = GiftCardFilterId | 'other';

export const GIFT_CARD_FILTERS: { id: GiftCardFilterId; label: string; icon: string }[] = [
  { id: 'all', label: 'All', icon: '✨' },
  { id: 'food', label: 'Food & drink', icon: '🍔' },
  { id: 'shopping', label: 'Shopping', icon: '🛍️' },
  { id: 'travel', label: 'Travel', icon: '✈️' },
  { id: 'beauty', label: 'Beauty', icon: '💄' },
];

const BRAND_CATEGORY_MAP: Record<string, GiftCardFilterId> = {
  starbucks: 'food',
  ubereats: 'food',
  'uber eats': 'food',
  doordash: 'food',
  hellofresh: 'food',
  amazon: 'shopping',
  walmart: 'shopping',
  visa: 'shopping',
  'visa prepaid': 'shopping',
  adidas: 'shopping',
  bathandbodyworks: 'shopping',
  'bath & body works': 'shopping',
  lululemon: 'shopping',
  nike: 'shopping',
  airbnb: 'travel',
  lyft: 'travel',
  uber: 'travel',
  turo: 'travel',
  lush: 'beauty',
  sephora: 'beauty',
};

export const getGiftCardCategory = (name: string, brandCode: string): GiftCardCategory => {
  const key = name.trim().toLowerCase();
  const codeKey = brandCode.trim().toLowerCase();
  return BRAND_CATEGORY_MAP[key] ?? BRAND_CATEGORY_MAP[codeKey] ?? 'other';
};
